export enum PaymentEnums {
    MailRequest = 'checkoutMail',
    Paypal = 'checkoutPayPal',
    DebitCharge = 'checkoutDebit',
    CreditCharge = 'checkoutCredit',
}